class CnerIgnoregitConfig {
  static developer_geek = 'test';
}

export default CnerIgnoregitConfig;
